<nav class="nav">
  <div class="nav-arrows">
    <button
      type="button"
      class="nav-arrow"
      aria-label="Previous item"
      [disabled]="!hasPrev()"
      [dataSelector]="'cxp-crl-overlay-prev'"
      (click)="prev.emit()"
    >
      <aiwyn-icon name="arrow-left" [height]="18" [width]="18"></aiwyn-icon>
    </button>
    <button
      type="button"
      class="nav-arrow"
      aria-label="Next item"
      [disabled]="!hasNext()"
      [dataSelector]="'cxp-crl-overlay-next'"
      (click)="next.emit()"
    >
      <aiwyn-icon name="arrow-right" [height]="18" [width]="18"></aiwyn-icon>
    </button>
  </div>

  <ol class="nav-breadcrumb" aria-label="Breadcrumb">
    <li class="nav-crumb">Projects</li>
    <li class="nav-sep" aria-hidden="true">
      <aiwyn-icon name="chevron-right" [height]="14" [width]="14"></aiwyn-icon>
    </li>
    @if (requestName()) {
      <li class="nav-crumb">{{ requestName() }}</li>
      <li class="nav-sep" aria-hidden="true">
        <aiwyn-icon name="chevron-right" [height]="14" [width]="14"></aiwyn-icon>
      </li>
    }
    <li class="nav-crumb nav-crumb-current" aria-current="page">
      @if (displayNumber()) {
        <span class="nav-crumb-number">{{ displayNumber() }}</span>
      }
      {{ itemTitle() ?? 'Request item' }}
    </li>
  </ol>

  <button
    type="button"
    class="nav-close"
    aria-label="Close"
    [dataSelector]="'cxp-crl-overlay-close'"
    (click)="closed.emit()"
  >
    <aiwyn-icon name="x" [height]="20" [width]="20"></aiwyn-icon>
  </button>
</nav>
